import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Tooltip,
    Filler
} from "chart.js";

import { Bar } from "react-chartjs-2";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Tooltip,
    Filler
);

const FailureTrendChart = ({ data }) => {

    const chartData = {
        labels: data.map(x => x.hour),

        datasets: [
            {
                data: data.map(x => x.count),

                backgroundColor: "#ff4d4f",

                borderSkipped: false,

                barThickness: 2,

                maxBarThickness: 2,

                categoryPercentage: 1,

                barPercentage: 1
            }
        ]
    };

    const options = {

        responsive: true,

        maintainAspectRatio: false,

        animation: false,

        plugins: {

            legend: {
                display: false
            },
            tooltip: {
                filter: function (tooltipItem) {
                    return tooltipItem.raw > 0;
                },
                callbacks: {
                    title: () => "", // Hide title

                    label: function (context) {

                        const hour = data[context.dataIndex].hour;
                        const count = data[context.dataIndex].count;

                        return `${hour} (${count})`;
                    }
                }
            }
        },

        scales: {

            x: {

                display: false,

                offset: false,

                grid: {
                    display: false
                }
            },

            y: {

                display: false,

                beginAtZero: true,

                grid: {
                    display: false
                }
            }
        }
    }

    return (
        <div style={{ width: 96, height: 28 }}>
            <Bar data={chartData} options={options} />
        </div>
    );
};

export default FailureTrendChart;